module.exports = __webpack_public_path__ + "img/14.7bb353c4.png";